import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { PageWrapper } from "../../components";
import { notificationAction } from "../../actions";

import "./snapshot.scss";
import {
  getAcceptedcollaborationapi,
  tictellLogin,
  getCurrenciesApi,
  getExpensesCategoriesApi,
  tictellAppLoginApi,
} from "../Tictell/tictellApi";
import { privateRoutes } from "../../Routes/routing";
import {
  getAllCollaborationsApi,
  GetAcceptedCollaborationCount,
  getChildFeatureByName,
} from "../Snapshot/snapshotApi";
import { StorageService } from "../../api";
import SnapshotNavigation from "./Navigation/Navigation";
import Reports from "./views/Reports/Reports";
import { ConfirmDialog, LoadingMask } from "../../common";
import Collaborations from "./views/Collaborations/Collaborations";
import Dashboard from "./views/Dashboard/Dashboard";
import Pools from "./views/Pools/Pools";

class Snapshot extends Component {
  state = {
    UserFeatures: [],
    token: "",
    ExpenseCategories: [],
    Currencies: [],
    isLoading: true,
    UserId: -1,
    dialogMessage: "",
  };
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    const firstUrl = this.state.UserFeatures.find(a=> a.Url);
    var queryString = window.location.href;
    queryString = queryString.toLowerCase().split("snapshot")[1];
    if (queryString == "") {
      if (firstUrl) {
        const isApp = window.location.hash.toLowerCase().indexOf("apps") > -1;
        this.props.history.push(
          (isApp ? "/apps" : "") + "/snapshot/" + firstUrl.Url
        );
      }
    }
  }
  componentDidMount() {
    getChildFeatureByName({ featureName: 'snapshot' })
      .then((res) => {
        this.setState({
          UserFeatures: res.items,
        });
        const { items } = res;
        const firstUrl = items.find(a=> a.Url);
        var queryString = window.location.href;
        queryString = queryString.toLowerCase().split("snapshot")[1];
        if (queryString == "") {
          if (firstUrl) {
            const isApp =
              window.location.hash.toLowerCase().indexOf("apps") > -1;
            this.props.history.push(
              (isApp ? "/apps" : "") + "/snapshot/" + firstUrl.Url
            );
          }
        }
      })
      .catch((err) => console.log("Err ", err));

    let { UserEmail } = this.props.User;
    let Email = UserEmail;
    if (!Email) {
      const User = StorageService.getUser();
      Email = User.Email;
    }
    this.setState({
      UserId: this.props.User.UserId,
    });
    tictellAppLoginApi(Email)
      .then((res) => {
        if (res.success) {
          tictellLogin(Email)
            .then((res) => {
              if (res.success) {
                const { access_token } = res.items;
                this.getCurrencies(access_token);
                this.getAllactivecollaborations(access_token);
                this.setState({
                  token: access_token,
                });
              }
            })
            .catch((err) => console.log(err));
        }
      })
      .catch((Err) => console.log("Error ", Err));
  }
  getAllactivecollaborations(access_token) {
    GetAcceptedCollaborationCount(access_token).then((res) => {
      if (res.success) {
        if (res.items.acceptedColl === 0) {
          this.setState({
            dialogMessage: this.props.labels.Snapshot_Collaboration_Dialog_Msg,
            isLoading: true,
          });
        } else {
          this.setState({
            isLoading: false,
          });
        }
      }
    });
  }
  getCurrencies(access_token) {
    getCurrenciesApi()
      .then((res) => {
        if (res.success) {
          this.setState({
            Currencies: res.items.map((item) => ({
              ...item,
              value: item.CurrencyId,
              label: item.Name,
            })),
          });
          this.getExpenseCategories(access_token);
        }
      })
      .catch((err) => console.log("Err ", err));
  }
  getExpenseCategories(access_token) {
    getExpensesCategoriesApi(access_token)
      .then((res) => {
        if (res.success) {
          this.setState({
            ExpenseCategories: res.items.map((item) => ({
              ...item,
              value: item.ExpenseCategoryId,
              label: item.Title,
            })),
          });
        }
      })
      .catch((err) => console.log("Err ", err));
  }
  handleOkClick = () => {
    this.props.history.push(privateRoutes.dashboard.path);
  };
  render() {
    const { labels, isHelpActive, location } = this.props;
    const {
      UserFeatures,
      token,
      Currencies,
      dialogMessage,
      ExpenseCategories,
      isLoading,
      UserId,
      pendingtimesheet,
      Rejectedtimesheet,
      Rejectedexpense,
      Pendingexpense,
    } = this.state;
    const hashesList = [
      "#/apps/snapshot/",
      "#/snapshot/",
      "#/apps/snapshot",
      "#/snapshot",
    ];
    const currentViewHash =
      window.location.hash.toLowerCase().split("/")[1] == "apps"
        ? window.location.hash.toLocaleLowerCase().split("/")[3]
        : window.location.hash.toLocaleLowerCase().split("/")[2];
    return (
      <PageWrapper className={`snapshot-page`}>
        {isLoading && (
          <div id="loader-wrapper">
            <div test-data-id={"loader"} id="loader" />
          </div>
        )}
        <SnapshotNavigation
          labels={labels}
          disabled={`${isLoading ? "disabled" : ""}`}
          isHelpActive={isHelpActive}
          UserFeatures={UserFeatures}
        />
        {dialogMessage && (
          <ConfirmDialog testId="confirm-diloag">
            <ConfirmDialog.Message>{dialogMessage}</ConfirmDialog.Message>
            <ConfirmDialog.ActionButtons>
              <ConfirmDialog.Button
                className="dialog-btn"
                onClick={this.handleOkClick}
              >
                {"Ok"}
              </ConfirmDialog.Button>
            </ConfirmDialog.ActionButtons>
          </ConfirmDialog>
        )}
        {!isLoading && (
          <React.Fragment>
            {currentViewHash == "home" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <Dashboard
                  token={token}
                  Readyforapproval={pendingtimesheet}
                  Rejected={Rejectedtimesheet}
                  asOwnerCount={"12"}
                  Rejectedexpense={Rejectedexpense}
                  Pendingexpense={Pendingexpense}
                  UserFeatures={UserFeatures}
                />
              )}
            {currentViewHash == "reports" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <Reports
                  token={token}
                  Currencies={Currencies}
                  ExpenseCategories={ExpenseCategories}
                />
              )}
            {currentViewHash == "collaborations" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <Collaborations
                  token={token}
                  Currencies={Currencies}
                  ExpenseCategories={ExpenseCategories}
                  UserId={UserId}
                  locationProp={location}
                />
              )}
            {currentViewHash == "pools" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <Pools
                  token={token}
                  Currencies={Currencies}
                  ExpenseCategories={ExpenseCategories}
                  UserId={UserId}
                />
              )}
          </React.Fragment>
        )}
      </PageWrapper>
    );
  }
}
const mapStateToProps = ({ systemLabel, navigation, userInfo }) => {
  const { labels } = systemLabel;
  const { user } = userInfo;
  const User = user ? user : StorageService.getUser();
  const { isHelpActive } = navigation;
  return { labels, isHelpActive, User };
};
export default connect(
  mapStateToProps,
  { notificationAction }
)(Snapshot);
